import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumCacheEntityType implements BaseEnumType {
  private static allValues: EnumCacheEntityType[] = []; // make sure this is top-most
  
  public static none = new EnumCacheEntityType(0, "None", "enum_cache_entity_type_none");
  public static communicationSubject = new EnumCacheEntityType(1, "CommunicationSubject", "enum_cache_entity_type_communication_subject");
  public static communicationType = new EnumCacheEntityType(2, "CommunicationType", "enum_cache_entity_type_communication_type");
  public static courier = new EnumCacheEntityType(3, "Courier", "enum_cache_entity_type_courier");
  public static creditTerm = new EnumCacheEntityType(4, "CreditTerm", "enum_cache_entity_type_credit_term");
  public static deliveryArea = new EnumCacheEntityType(5, "DeliveryArea", "enum_cache_entity_type_delivery_area");
  public static glCode = new EnumCacheEntityType(6, "GlCode", "enum_cache_entity_type_gl_code");
  public static outletRating = new EnumCacheEntityType(7, "OutletRating", "enum_cache_entity_type_outlet_rating");
  public static outletType = new EnumCacheEntityType(8, "OutletType", "enum_cache_entity_type_outlet_type");
  public static packageType = new EnumCacheEntityType(9, "PackageType", "enum_cache_entity_type_package_type");
  public static pricingCategory = new EnumCacheEntityType(10, "PricingCategory", "enum_cache_entity_type_pricing_category");
  public static productBrand = new EnumCacheEntityType(11, "ProductBrand", "enum_cache_entity_type_product_brand");
  public static qcTest = new EnumCacheEntityType(12, "QcTest", "enum_cache_entity_type_qc_test");
  public static salesArea = new EnumCacheEntityType(13, "SalesArea", "enum_cache_entity_type_sales_area");
  public static salesCode = new EnumCacheEntityType(14, "SalesCode", "enum_cache_entity_type_sales_code");
  public static stockGroup = new EnumCacheEntityType(15, "StockGroup", "enum_cache_entity_type_stock_group");
  public static stockLocation = new EnumCacheEntityType(16, "StockLocation", "enum_cache_entity_type_stock_location");
  public static taskQueue = new EnumCacheEntityType(17, "TaskQueue", "enum_cache_entity_type_task_queue");
  public static taskType = new EnumCacheEntityType(18, "TaskType", "enum_cache_entity_type_task_type");
  public static unitOfMeasure = new EnumCacheEntityType(19, "UnitOfMeasure", "enum_cache_entity_type_unit_of_measure");
  public static vatCode = new EnumCacheEntityType(20, "VatCode", "enum_cache_entity_type_vat_code");
  public static vehicle = new EnumCacheEntityType(21, "Vehicle", "enum_cache_entity_type_vehicle");
  public static vesselMaintenanceProcess = new EnumCacheEntityType(22, "VesselMaintenanceProcess", "enum_cache_entity_type_vessel_maintenance_process");
  public static vesselType = new EnumCacheEntityType(23, "VesselType", "enum_cache_entity_type_vessel_type");
  public static vessel = new EnumCacheEntityType(24, "Vessel", "enum_cache_entity_type_vessel");
  public static leadLossReason = new EnumCacheEntityType(25, "LeadLossReason", "enum_cache_entity_type_lead_loss_reason");
  public static leadPipelineStage = new EnumCacheEntityType(26, "LeadPipelineStage", "enum_cache_entity_type_lead_pipeline_stage");
  public static leadSource = new EnumCacheEntityType(27, "LeadSource", "enum_cache_entity_type_lead_source");
  public static priceList = new EnumCacheEntityType(28, "PriceList", "enum_cache_entity_type_price_list");
  public static outlet = new EnumCacheEntityType(30, "Outlet", "enum_cache_entity_type_outlet");
  public static group = new EnumCacheEntityType(31, "Group", "enum_cache_entity_type_group");
  public static supplierManufacturer = new EnumCacheEntityType(32, "SupplierManufacturer", "enum_cache_entity_type_supplier_manufacturer");
  public static palletType = new EnumCacheEntityType(33, "PalletType", "enum_cache_entity_type_pallet_type");
  public static item = new EnumCacheEntityType(34, "Item", "enum_cache_entity_type_item");
  public static distributionCentre = new EnumCacheEntityType(35, "DistributionCentre", "enum_cache_entity_type_distribution_centre");
  public static vesselState = new EnumCacheEntityType(36, "VesselState", "enum_cache_entity_type_vessel_state");
  public static caskType = new EnumCacheEntityType(37, "CaskType", "enum_cache_entity_type_cask_type");
  public static caskSubType = new EnumCacheEntityType(38, "CaskSubType", "enum_cache_entity_type_cask_sub_type");
  public static obsolete_CaskLocation = new EnumCacheEntityType(39, "Obsolete_CaskLocation", "enum_cache_entity_type_obsolete__cask_location");
  public static caskSubLocation = new EnumCacheEntityType(40, "CaskSubLocation", "enum_cache_entity_type_cask_sub_location");
  public static caskSubSubLocation = new EnumCacheEntityType(41, "CaskSubSubLocation", "enum_cache_entity_type_cask_sub_sub_location");
  public static taskNotificationSetting = new EnumCacheEntityType(42, "TaskNotificationSetting", "enum_cache_entity_type_task_notification_setting");
  public static lead = new EnumCacheEntityType(43, "Lead", "enum_cache_entity_type_lead");
  public static vesselCapability = new EnumCacheEntityType(44, "VesselCapability", "enum_cache_entity_type_vessel_capability");
  public static orderTypeText = new EnumCacheEntityType(45, "OrderTypeText", "enum_cache_entity_type_order_type_text");
  public static recipe = new EnumCacheEntityType(46, "Recipe", "enum_cache_entity_type_recipe");
  public static batchTemplate = new EnumCacheEntityType(47, "BatchTemplate", "enum_cache_entity_type_batch_template");
  public static tenantSettings = new EnumCacheEntityType(48, "TenantSettings", "enum_cache_entity_type_tenant_settings");
  public static tenant = new EnumCacheEntityType(49, "Tenant", "enum_cache_entity_type_tenant");
  public static outletSubType = new EnumCacheEntityType(50, "OutletSubType", "enum_cache_entity_type_outlet_sub_type");
  public static collectionTime = new EnumCacheEntityType(51, "CollectionTime", "enum_cache_entity_type_collection_time");
  public static accountsLink = new EnumCacheEntityType(52, "AccountsLink", "enum_cache_entity_type_accounts_link");
  public static vesselValuation = new EnumCacheEntityType(53, "VesselValuation", "enum_cache_entity_type_vessel_valuation");
  public static regionalTax = new EnumCacheEntityType(54, "RegionalTax", "enum_cache_entity_type_regional_tax");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCacheEntityType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumCacheEntityType.none; }
  public isCommunicationSubject() { return this === EnumCacheEntityType.communicationSubject; }
  public isCommunicationType() { return this === EnumCacheEntityType.communicationType; }
  public isCourier() { return this === EnumCacheEntityType.courier; }
  public isCreditTerm() { return this === EnumCacheEntityType.creditTerm; }
  public isDeliveryArea() { return this === EnumCacheEntityType.deliveryArea; }
  public isGlCode() { return this === EnumCacheEntityType.glCode; }
  public isOutletRating() { return this === EnumCacheEntityType.outletRating; }
  public isOutletType() { return this === EnumCacheEntityType.outletType; }
  public isPackageType() { return this === EnumCacheEntityType.packageType; }
  public isPricingCategory() { return this === EnumCacheEntityType.pricingCategory; }
  public isProductBrand() { return this === EnumCacheEntityType.productBrand; }
  public isQcTest() { return this === EnumCacheEntityType.qcTest; }
  public isSalesArea() { return this === EnumCacheEntityType.salesArea; }
  public isSalesCode() { return this === EnumCacheEntityType.salesCode; }
  public isStockGroup() { return this === EnumCacheEntityType.stockGroup; }
  public isStockLocation() { return this === EnumCacheEntityType.stockLocation; }
  public isTaskQueue() { return this === EnumCacheEntityType.taskQueue; }
  public isTaskType() { return this === EnumCacheEntityType.taskType; }
  public isUnitOfMeasure() { return this === EnumCacheEntityType.unitOfMeasure; }
  public isVatCode() { return this === EnumCacheEntityType.vatCode; }
  public isVehicle() { return this === EnumCacheEntityType.vehicle; }
  public isVesselMaintenanceProcess() { return this === EnumCacheEntityType.vesselMaintenanceProcess; }
  public isVesselType() { return this === EnumCacheEntityType.vesselType; }
  public isVessel() { return this === EnumCacheEntityType.vessel; }
  public isLeadLossReason() { return this === EnumCacheEntityType.leadLossReason; }
  public isLeadPipelineStage() { return this === EnumCacheEntityType.leadPipelineStage; }
  public isLeadSource() { return this === EnumCacheEntityType.leadSource; }
  public isPriceList() { return this === EnumCacheEntityType.priceList; }
  public isOutlet() { return this === EnumCacheEntityType.outlet; }
  public isGroup() { return this === EnumCacheEntityType.group; }
  public isSupplierManufacturer() { return this === EnumCacheEntityType.supplierManufacturer; }
  public isPalletType() { return this === EnumCacheEntityType.palletType; }
  public isItem() { return this === EnumCacheEntityType.item; }
  public isDistributionCentre() { return this === EnumCacheEntityType.distributionCentre; }
  public isVesselState() { return this === EnumCacheEntityType.vesselState; }
  public isCaskType() { return this === EnumCacheEntityType.caskType; }
  public isCaskSubType() { return this === EnumCacheEntityType.caskSubType; }
  public isObsolete_CaskLocation() { return this === EnumCacheEntityType.obsolete_CaskLocation; }
  public isCaskSubLocation() { return this === EnumCacheEntityType.caskSubLocation; }
  public isCaskSubSubLocation() { return this === EnumCacheEntityType.caskSubSubLocation; }
  public isTaskNotificationSetting() { return this === EnumCacheEntityType.taskNotificationSetting; }
  public isLead() { return this === EnumCacheEntityType.lead; }
  public isVesselCapability() { return this === EnumCacheEntityType.vesselCapability; }
  public isOrderTypeText() { return this === EnumCacheEntityType.orderTypeText; }
  public isRecipe() { return this === EnumCacheEntityType.recipe; }
  public isBatchTemplate() { return this === EnumCacheEntityType.batchTemplate; }
  public isTenantSettings() { return this === EnumCacheEntityType.tenantSettings; }
  public isTenant() { return this === EnumCacheEntityType.tenant; }
  public isOutletSubType() { return this === EnumCacheEntityType.outletSubType; }
  public isCollectionTime() { return this === EnumCacheEntityType.collectionTime; }
  public isAccountsLink() { return this === EnumCacheEntityType.accountsLink; }
  public isVesselValuation() { return this === EnumCacheEntityType.vesselValuation; }
  public isRegionalTax() { return this === EnumCacheEntityType.regionalTax; }

  public static getValues(): readonly EnumCacheEntityType[] {
    return EnumCacheEntityType.allValues;
  }

  public static getValuesExcept0(): readonly EnumCacheEntityType[] {
    return EnumCacheEntityType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCacheEntityType {
    const found = EnumCacheEntityType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCacheEntityType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCacheEntityType): EnumCacheEntityType {
    const found = name ? EnumCacheEntityType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCacheEntityType - Value not found: ${ name }`);
    }

    return found;
  }
}